import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['root', 'message', 'icon'];
    static classes = ['show', 'red'];

    connect() {
        this.handler = (event) => this.show(event.detail || {});
        document.addEventListener('gymplus:toast', this.handler);

        const raw = sessionStorage.getItem('pending_toast');
        if (raw) {
            sessionStorage.removeItem('pending_toast');
            try { this.show(JSON.parse(raw)); } catch (_) {}
        }
    }

    disconnect() {
        document.removeEventListener('gymplus:toast', this.handler);
        clearTimeout(this.timer);
    }

    show({ message = '', variant = 'success' } = {}) {
        document.dispatchEvent(new CustomEvent('gymplus:ui:close-overlays'));

        if (!this.hasMessageTarget) return;

        this.messageTarget.textContent = message;
        this.iconTarget.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M2.5 7l3 3 6-5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;

        this.element.classList.toggle(this.redClass, variant === 'red' || variant === 'error');

        clearTimeout(this.timer);
        requestAnimationFrame(() => {
            this.element.classList.add(this.showClass);
        });

        this.timer = setTimeout(() => {
            this.element.classList.remove(this.showClass);
        }, 3200);
    }
}
